import { Component, inject } from '@angular/core';
import { BaseComponent, DialogRef } from '@shared/classes';
import { ButtonComponent } from '@shared/components/button/button.component';
import { SubType } from '@shared/constants';
import { FrequencyChallenge } from '@shared/factory';
import {
  DIALOG_DATA,
  DialogCloseButton,
  DialogText,
  VisitInfoDialog,
} from '@shared/models';
import { SafePipe, VariableReplacementPipe } from '@shared/pipes';

@Component({
  selector: 'b2c-visit-info-modal',
  styleUrl: './visit-info-modal.component.scss',
  templateUrl: './visit-info-modal.component.html',
  imports: [ButtonComponent, SafePipe, VariableReplacementPipe],
})
export class VisitInfoModalComponent extends BaseComponent {
  public config: VisitInfoDialog = this.loyaltyChallengeConfig.components.modals
    .visitInfo as VisitInfoDialog;

  public closeButtonConfig: DialogCloseButton =
    this.loyaltyChallengeConfig.components.modals.closeButton;

  public data: FrequencyChallenge = inject<{ data: FrequencyChallenge }>(
    DIALOG_DATA
  ).data;

  private readonly dialogRef: DialogRef = inject(DialogRef);

  get title(): DialogText | undefined {
    return this.resolveBySubType(this.config.titleBySubType);
  }

  get body(): DialogText | undefined {
    return this.resolveBySubType(this.config.bodyBySubType);
  }

  private resolveBySubType(
    map: Partial<Record<SubType, DialogText>> | undefined
  ): DialogText | undefined {
    return map?.[this.data.subType] ?? map?.[SubType.DEFAULT];
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
